module.exports = __webpack_public_path__ + "img/marie-de-burbure.567642ba.png";